const formatCNPJ = (cnpj) => {
  if (!cnpj) return '';

  if (cnpj.toString().length !== 14) {
    throw new Error('CNPJ inválido. Deve conter 14 dígitos.');
  }

  return cnpj.toString().replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
    '$1.$2.$3/$4-$5'
  );
};

const returnOnlyNumbers = (string) => {
  if (!string) return '';

  return string.toString().replace(/\D/g, '');
};

const formatDateTime = (dateString) => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

const formatDate = (dateString, separator = '/') => {
  const arrayDate = dateString.split('-');
  return `${arrayDate[2]}${separator}${arrayDate[1]}${separator}${arrayDate[0]}`;
}

export {
  formatCNPJ,
  returnOnlyNumbers,
  formatDateTime,
  formatDate,
}
